module.exports = __webpack_public_path__ + "img/c07_unitram_Normal_ua.34ec1e99.webp";